<div id="st-empty-state-block"
  class="empty-state d-flex flex-column align-items-center justify-content-center text-center p-4">
  <div class="empty-state-icon d-flex align-items-center justify-content-center mb-3">
    <svg class="empty-state-icon-svg" viewBox="0 0 64 64" aria-hidden="true">

      @switch (purpose()) {

      @case ('no-results') {
      <defs>
        <linearGradient id="es-nr-paper" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stop-color="var(--st-white)" />
          <stop offset="100%" stop-color="var(--st-ui-empty-icon-bg)" />
        </linearGradient>
        <linearGradient id="es-nr-lens" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="var(--st-ui-empty-icon-color)" stop-opacity="0.06" />
          <stop offset="100%" stop-color="var(--st-ui-empty-icon-color)" stop-opacity="0.28" />
        </linearGradient>
      </defs>

      <!-- ground shadow -->
      <ellipse cx="34" cy="57" rx="22" ry="2.4" fill="var(--st-ui-empty-icon-color)" opacity="0.12" />

      <!-- back paper (rotated) -->
      <g transform="rotate(-9 22 30)">
        <rect x="10" y="14" width="22" height="29" rx="2.5" fill="var(--st-ui-empty-icon-bg)"
          stroke="var(--st-ui-empty-icon-color)" stroke-width="1.2" opacity="0.7" />
        <line x1="15" y1="22" x2="27" y2="22" stroke="var(--st-ui-empty-icon-color)" stroke-width="1.2"
          stroke-linecap="round" opacity="0.35" />
        <line x1="15" y1="27" x2="27" y2="27" stroke="var(--st-ui-empty-icon-color)" stroke-width="1.2"
          stroke-linecap="round" opacity="0.35" />
        <line x1="15" y1="32" x2="23" y2="32" stroke="var(--st-ui-empty-icon-color)" stroke-width="1.2"
          stroke-linecap="round" opacity="0.35" />
      </g>

      <!-- front paper -->
      <g transform="rotate(4 24 30)">
        <rect x="13" y="13" width="22" height="29" rx="2.5" fill="url(#es-nr-paper)"
          stroke="var(--st-ui-empty-icon-color)" stroke-width="1.5" />
        <line x1="18" y1="20" x2="30" y2="20" stroke="var(--st-ui-empty-icon-color)" stroke-width="1.4"
          stroke-linecap="round" opacity="0.5" />
        <line x1="18" y1="25" x2="30" y2="25" stroke="var(--st-ui-empty-icon-color)" stroke-width="1.4"
          stroke-linecap="round" opacity="0.5" />
        <line x1="18" y1="30" x2="26" y2="30" stroke="var(--st-ui-empty-icon-color)" stroke-width="1.4"
          stroke-linecap="round" opacity="0.5" />
      </g>

      <!-- magnifying glass (animated pulse) -->
      <g>
        <animateTransform attributeName="transform" type="translate" values="0 0; 0 -1.5; 0 0" dur="3s"
          repeatCount="indefinite" calcMode="spline" keyTimes="0;0.5;1" keySplines="0.4 0 0.6 1;0.4 0 0.6 1" />
        <circle cx="42" cy="32" r="12" fill="url(#es-nr-lens)" stroke="var(--st-ui-empty-icon-color)"
          stroke-width="3.2" />
        <!-- specular highlight on lens -->
        <path d="M36 26 a8 8 0 0 1 6 -3" fill="none" stroke="var(--st-white)" stroke-width="2.2" stroke-linecap="round"
          opacity="0.75" />
        <circle cx="38" cy="29" r="1.4" fill="var(--st-white)" opacity="0.7" />
        <!-- handle -->
        <line x1="51" y1="41" x2="58.5" y2="48.5" stroke="var(--st-ui-empty-icon-color)" stroke-width="5.5"
          stroke-linecap="round" />
        <line x1="51" y1="41" x2="58.5" y2="48.5" stroke="var(--st-white)" stroke-width="1.4" stroke-linecap="round"
          opacity="0.25" />
      </g>
      }

      @case ('no-records') {
      <defs>
        <linearGradient id="es-nrec-board" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stop-color="var(--st-white)" />
          <stop offset="100%" stop-color="var(--st-ui-empty-icon-bg)" />
        </linearGradient>
        <linearGradient id="es-nrec-clip" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stop-color="var(--st-ui-empty-icon-color)" stop-opacity="0.9" />
          <stop offset="100%" stop-color="var(--st-ui-empty-icon-color)" />
        </linearGradient>
      </defs>

      <!-- ground shadow -->
      <ellipse cx="32" cy="57" rx="20" ry="2.4" fill="var(--st-ui-empty-icon-color)" opacity="0.12" />

      <!-- board -->
      <rect x="15" y="13" width="34" height="42" rx="5" fill="url(#es-nrec-board)"
        stroke="var(--st-ui-empty-icon-color)" stroke-width="2.2" />

      <!-- inner paper -->
      <rect x="19" y="20" width="26" height="31" rx="2" fill="var(--st-white)" opacity="0.75" />
      <line x1="23" y1="26" x2="41" y2="26" stroke="var(--st-ui-empty-icon-color)" stroke-width="1.2"
        stroke-linecap="round" opacity="0.25" />
      <line x1="23" y1="30" x2="38" y2="30" stroke="var(--st-ui-empty-icon-color)" stroke-width="1.2"
        stroke-linecap="round" opacity="0.25" />

      <!-- clip -->
      <rect x="25" y="7" width="14" height="11" rx="2.5" fill="url(#es-nrec-clip)" />
      <rect x="29" y="9.5" width="6" height="4" rx="1.5" fill="var(--st-white)" opacity="0.45" />

      <!-- X mark (animated subtle scale) -->
      <g>
        <animateTransform attributeName="transform" type="scale" values="1;1.06;1" dur="2.6s" repeatCount="indefinite"
          additive="sum" calcMode="spline" keyTimes="0;0.5;1" keySplines="0.4 0 0.6 1;0.4 0 0.6 1" />
        <animateTransform attributeName="transform" type="translate" values="0 0; -1.92 -2.4; 0 0" dur="2.6s"
          repeatCount="indefinite" additive="sum" calcMode="spline" keyTimes="0;0.5;1"
          keySplines="0.4 0 0.6 1;0.4 0 0.6 1" />
        <circle cx="32" cy="40" r="9" fill="var(--st-ui-empty-icon-bg)" stroke="var(--st-ui-empty-icon-color)"
          stroke-width="2.4" />
        <line x1="28.4" y1="36.4" x2="35.6" y2="43.6" stroke="var(--st-ui-empty-icon-color)" stroke-width="2.8"
          stroke-linecap="round" />
        <line x1="35.6" y1="36.4" x2="28.4" y2="43.6" stroke="var(--st-ui-empty-icon-color)" stroke-width="2.8"
          stroke-linecap="round" />
      </g>
      }

      @case ('no-live-matches') {
      <defs>
        <linearGradient id="es-nlive-stand" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stop-color="var(--st-ui-empty-icon-color)" stop-opacity="0.85" />
          <stop offset="100%" stop-color="var(--st-ui-empty-icon-color)" />
        </linearGradient>
        <linearGradient id="es-nlive-roof" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stop-color="var(--st-ui-empty-icon-color)" stop-opacity="0.25" />
          <stop offset="100%" stop-color="var(--st-ui-empty-icon-color)" stop-opacity="0.45" />
        </linearGradient>
      </defs>

      <!-- clouds -->
      <g fill="var(--st-greyscale-grey-1)" opacity="0.5">
        <ellipse cx="12" cy="12" rx="4" ry="2.4" />
        <ellipse cx="15" cy="10.5" rx="3" ry="2.6" />
        <ellipse cx="50" cy="9" rx="3.4" ry="2" />
        <ellipse cx="53" cy="8" rx="2.4" ry="2.2" />
      </g>

      <!-- flag poles -->
      <g stroke="var(--st-ui-empty-icon-color)" stroke-width="1.4" stroke-linecap="round">
        <line x1="14" y1="30" x2="14" y2="18" />
        <line x1="23" y1="30" x2="23" y2="14" />
        <line x1="32" y1="30" x2="32" y2="11" />
        <line x1="41" y1="30" x2="41" y2="14" />
        <line x1="50" y1="30" x2="50" y2="18" />
      </g>

      <!-- waving flags -->
      <g fill="var(--st-ui-empty-icon-color)">
        <path d="M14 18 Q17 19.5 21 19.5 L19 22 L21 24.5 Q17 24.5 14 23 Z">
          <animate attributeName="d" values="M14 18 Q17 19.5 21 19.5 L19 22 L21 24.5 Q17 24.5 14 23 Z;
                        M14 18 Q17 18.5 21 20.5 L19 22 L21 23.5 Q17 25.5 14 22 Z;
                        M14 18 Q17 19.5 21 19.5 L19 22 L21 24.5 Q17 24.5 14 23 Z" dur="2.4s"
            repeatCount="indefinite" />
        </path>
        <path d="M23 14 Q26 15.5 30 15.5 L28 18 L30 20.5 Q26 20.5 23 19 Z">
          <animate attributeName="d" values="M23 14 Q26 15.5 30 15.5 L28 18 L30 20.5 Q26 20.5 23 19 Z;
                        M23 14 Q26 15 30 16.5 L28 18 L30 19.5 Q26 21.5 23 18 Z;
                        M23 14 Q26 15.5 30 15.5 L28 18 L30 20.5 Q26 20.5 23 19 Z" dur="2.4s" begin="0.2s"
            repeatCount="indefinite" />
        </path>
        <path d="M32 11 Q35 12.5 39 12.5 L37 15 L39 17.5 Q35 17.5 32 16 Z">
          <animate attributeName="d" values="M32 11 Q35 12.5 39 12.5 L37 15 L39 17.5 Q35 17.5 32 16 Z;
                        M32 11 Q35 12 39 13.5 L37 15 L39 16.5 Q35 18.5 32 15 Z;
                        M32 11 Q35 12.5 39 12.5 L37 15 L39 17.5 Q35 17.5 32 16 Z" dur="2.4s" begin="0.4s"
            repeatCount="indefinite" />
        </path>
        <path d="M41 14 Q44 15.5 48 15.5 L46 18 L48 20.5 Q44 20.5 41 19 Z">
          <animate attributeName="d" values="M41 14 Q44 15.5 48 15.5 L46 18 L48 20.5 Q44 20.5 41 19 Z;
                        M41 14 Q44 15 48 16.5 L46 18 L48 19.5 Q44 21.5 41 18 Z;
                        M41 14 Q44 15.5 48 15.5 L46 18 L48 20.5 Q44 20.5 41 19 Z" dur="2.4s" begin="0.6s"
            repeatCount="indefinite" />
        </path>
        <path d="M50 18 Q53 19.5 57 19.5 L55 22 L57 24.5 Q53 24.5 50 23 Z">
          <animate attributeName="d" values="M50 18 Q53 19.5 57 19.5 L55 22 L57 24.5 Q53 24.5 50 23 Z;
                        M50 18 Q53 18.5 57 20.5 L55 22 L57 23.5 Q53 25.5 50 22 Z;
                        M50 18 Q53 19.5 57 19.5 L55 22 L57 24.5 Q53 24.5 50 23 Z" dur="2.4s" begin="0.8s"
            repeatCount="indefinite" />
        </path>
      </g>

      <!-- stadium roof (curved) -->
      <path d="M6 32 Q32 26 58 32 L58 36 Q32 30 6 36 Z" fill="url(#es-nlive-roof)"
        stroke="var(--st-ui-empty-icon-color)" stroke-width="1.2" />

      <!-- stadium body -->
      <path d="M6 36 L58 36 L58 54 Q58 56 56 56 L8 56 Q6 56 6 54 Z" fill="url(#es-nlive-stand)"
        stroke="var(--st-ui-empty-icon-color)" stroke-width="1.6" />

      <!-- windows / seats -->
      <g fill="var(--st-white)" opacity="0.42">
        <rect x="11" y="41" width="3" height="3" rx="0.6" />
        <rect x="17" y="41" width="3" height="3" rx="0.6" />
        <rect x="23" y="41" width="3" height="3" rx="0.6" />
        <rect x="29" y="41" width="3" height="3" rx="0.6" />
        <rect x="35" y="41" width="3" height="3" rx="0.6" />
        <rect x="41" y="41" width="3" height="3" rx="0.6" />
        <rect x="47" y="41" width="3" height="3" rx="0.6" />
        <rect x="14" y="47" width="3" height="3" rx="0.6" />
        <rect x="20" y="47" width="3" height="3" rx="0.6" />
        <rect x="26" y="47" width="3" height="3" rx="0.6" />
        <rect x="32" y="47" width="3" height="3" rx="0.6" />
        <rect x="38" y="47" width="3" height="3" rx="0.6" />
        <rect x="44" y="47" width="3" height="3" rx="0.6" />
        <rect x="50" y="47" width="3" height="3" rx="0.6" />
      </g>
      }

      @case ('no-matches-scheduled') {
      <defs>
        <linearGradient id="es-ncal-page" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stop-color="var(--st-white)" />
          <stop offset="100%" stop-color="var(--st-ui-empty-icon-bg)" />
        </linearGradient>
        <linearGradient id="es-ncal-header" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stop-color="var(--st-ui-empty-icon-color)" stop-opacity="0.95" />
          <stop offset="100%" stop-color="var(--st-ui-empty-icon-color)" />
        </linearGradient>
      </defs>

      <!-- ground shadow -->
      <ellipse cx="32" cy="58" rx="22" ry="2.4" fill="var(--st-ui-empty-icon-color)" opacity="0.12" />

      <!-- calendar body -->
      <rect x="11" y="13" width="42" height="42" rx="5" fill="url(#es-ncal-page)" stroke="var(--st-ui-empty-icon-color)"
        stroke-width="2" />

      <!-- header bar -->
      <path d="M11 18 a5 5 0 0 1 5 -5 h32 a5 5 0 0 1 5 5 v6 h-42 z" fill="url(#es-ncal-header)" />

      <!-- binding rings -->
      <rect x="20" y="9" width="3" height="9" rx="1.5" fill="var(--st-ui-empty-icon-color)" />
      <rect x="41" y="9" width="3" height="9" rx="1.5" fill="var(--st-ui-empty-icon-color)" />
      <circle cx="21.5" cy="13" r="0.9" fill="var(--st-white)" opacity="0.55" />
      <circle cx="42.5" cy="13" r="0.9" fill="var(--st-white)" opacity="0.55" />

      <!-- date grid (skipping center where X sits) -->
      <g fill="var(--st-ui-empty-icon-color)" opacity="0.3">
        <rect x="16" y="29" width="5" height="5" rx="1" />
        <rect x="23" y="29" width="5" height="5" rx="1" />
        <rect x="37" y="29" width="5" height="5" rx="1" />
        <rect x="44" y="29" width="5" height="5" rx="1" />
        <rect x="16" y="36" width="5" height="5" rx="1" />
        <rect x="23" y="36" width="5" height="5" rx="1" />
        <rect x="37" y="36" width="5" height="5" rx="1" />
        <rect x="44" y="36" width="5" height="5" rx="1" />
        <rect x="16" y="43" width="5" height="5" rx="1" />
        <rect x="23" y="43" width="5" height="5" rx="1" />
        <rect x="37" y="43" width="5" height="5" rx="1" />
        <rect x="44" y="43" width="5" height="5" rx="1" />
      </g>

      <!-- X overlay (animated pulse) -->
      <g>
        <animateTransform attributeName="transform" type="scale" values="1;1.07;1" dur="2.4s" repeatCount="indefinite"
          additive="sum" calcMode="spline" keyTimes="0;0.5;1" keySplines="0.4 0 0.6 1;0.4 0 0.6 1" />
        <animateTransform attributeName="transform" type="translate" values="0 0; -2.24 -2.66; 0 0" dur="2.4s"
          repeatCount="indefinite" additive="sum" calcMode="spline" keyTimes="0;0.5;1"
          keySplines="0.4 0 0.6 1;0.4 0 0.6 1" />
        <circle cx="32" cy="38" r="11" fill="var(--st-ui-empty-icon-bg)" stroke="var(--st-ui-empty-icon-color)"
          stroke-width="2.5" />
        <line x1="27.5" y1="33.5" x2="36.5" y2="42.5" stroke="var(--st-ui-empty-icon-color)" stroke-width="3"
          stroke-linecap="round" />
        <line x1="36.5" y1="33.5" x2="27.5" y2="42.5" stroke="var(--st-ui-empty-icon-color)" stroke-width="3"
          stroke-linecap="round" />
      </g>
      }

      @case ('no-tournaments') {
      <defs>
        <linearGradient id="es-ntroph-cup" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stop-color="var(--st-ui-empty-icon-bg)" />
          <stop offset="100%" stop-color="var(--st-ui-empty-icon-color)" stop-opacity="0.55" />
        </linearGradient>
        <linearGradient id="es-ntroph-base" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stop-color="var(--st-ui-empty-icon-color)" stop-opacity="0.85" />
          <stop offset="100%" stop-color="var(--st-ui-empty-icon-color)" />
        </linearGradient>
      </defs>

      <!-- sparkles -->
      <g fill="var(--st-ui-empty-icon-color)" opacity="0.5">
        <path d="M12 13 L13 16.5 L16.5 17.5 L13 18.5 L12 22 L11 18.5 L7.5 17.5 L11 16.5 Z">
          <animate attributeName="opacity" values="0.2;0.8;0.2" dur="2.6s" repeatCount="indefinite" />
        </path>
        <circle cx="51" cy="11" r="1.3">
          <animate attributeName="opacity" values="0.2;0.8;0.2" dur="2.6s" begin="0.6s" repeatCount="indefinite" />
        </circle>
        <circle cx="48" cy="18" r="0.9">
          <animate attributeName="opacity" values="0.2;0.8;0.2" dur="2.6s" begin="1.2s" repeatCount="indefinite" />
        </circle>
      </g>

      <!-- ground shadow -->
      <ellipse cx="32" cy="57" rx="15" ry="2" fill="var(--st-ui-empty-icon-color)" opacity="0.15" />

      <!-- floating trophy group -->
      <g>
        <animateTransform attributeName="transform" type="translate" values="0 0; 0 -2; 0 0" dur="3.4s"
          repeatCount="indefinite" calcMode="spline" keyTimes="0;0.5;1" keySplines="0.4 0 0.6 1;0.4 0 0.6 1" />

        <!-- handles -->
        <path d="M18 22 q-9 0 -9 8 q0 7 9 6" fill="none" stroke="var(--st-ui-empty-icon-color)" stroke-width="2.8"
          stroke-linecap="round" />
        <path d="M46 22 q9 0 9 8 q0 7 -9 6" fill="none" stroke="var(--st-ui-empty-icon-color)" stroke-width="2.8"
          stroke-linecap="round" />

        <!-- cup body -->
        <path d="M18 17 h28 l-3 18 q-11 9 -22 0 z" fill="url(#es-ntroph-cup)" stroke="var(--st-ui-empty-icon-color)"
          stroke-width="2.5" stroke-linejoin="round" />

        <!-- specular highlight -->
        <path d="M22 19 h3 l-2 14 q-1.5 -1 -2 -2 z" fill="var(--st-white)" opacity="0.45" />

        <!-- star emblem -->
        <polygon points="32,21 33.8,26 39,26.5 35,30 36.2,35 32,32 27.8,35 29,30 25,26.5 30.2,26"
          fill="var(--st-ui-empty-icon-color)" />

        <!-- stem -->
        <rect x="29" y="40" width="6" height="8" fill="var(--st-ui-empty-icon-color)" />
        <rect x="25" y="46" width="14" height="3" rx="1" fill="var(--st-ui-empty-icon-color)" />

        <!-- base -->
        <rect x="20" y="49" width="24" height="7" rx="2" fill="url(#es-ntroph-base)"
          stroke="var(--st-ui-empty-icon-color)" stroke-width="1.4" />
        <line x1="22" y1="51.2" x2="42" y2="51.2" stroke="var(--st-white)" stroke-width="1" opacity="0.35" />
      </g>
      }

      @case ('no-participants') {
      <defs>
        <linearGradient id="es-npart-bg" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stop-color="var(--st-greyscale-grey-1)" stop-opacity="0.7" />
          <stop offset="100%" stop-color="var(--st-greyscale-grey-1)" />
        </linearGradient>
        <linearGradient id="es-npart-fg" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stop-color="var(--st-ui-empty-icon-color)" stop-opacity="0.85" />
          <stop offset="100%" stop-color="var(--st-ui-empty-icon-color)" />
        </linearGradient>
      </defs>

      <!-- ground shadow -->
      <ellipse cx="32" cy="58" rx="24" ry="2.4" fill="var(--st-ui-empty-icon-color)" opacity="0.12" />

      <!-- ambient sparkles -->
      <circle cx="11" cy="11" r="1.5" fill="var(--st-greyscale-grey-1)" opacity="0.5" />
      <circle cx="53" cy="10" r="1.8" fill="var(--st-greyscale-grey-1)" opacity="0.5" />

      <!-- back-left person -->
      <circle cx="14" cy="27" r="6" fill="url(#es-npart-bg)" />
      <path d="M5 53 q0-13 9-13 q9 0 9 13 z" fill="url(#es-npart-bg)" />

      <!-- back-right person -->
      <circle cx="50" cy="27" r="6" fill="url(#es-npart-bg)" />
      <path d="M41 53 q0-13 9-13 q9 0 9 13 z" fill="url(#es-npart-bg)" />

      <!-- front-center person -->
      <circle cx="32" cy="21" r="8" fill="url(#es-npart-fg)" />
      <path d="M18 54 q0-16 14-16 q14 0 14 16 z" fill="url(#es-npart-fg)" />

      <!-- head highlight -->
      <ellipse cx="29" cy="18" rx="2.5" ry="1.4" fill="var(--st-white)" opacity="0.28" />

      <!-- minus badge (animated subtle pulse) -->
      <g>
        <animateTransform attributeName="transform" type="scale" values="1;1.06;1" dur="2.6s" repeatCount="indefinite"
          additive="sum" calcMode="spline" keyTimes="0;0.5;1" keySplines="0.4 0 0.6 1;0.4 0 0.6 1" />
        <animateTransform attributeName="transform" type="translate" values="0 0; -3 -2.88; 0 0" dur="2.6s"
          repeatCount="indefinite" additive="sum" calcMode="spline" keyTimes="0;0.5;1"
          keySplines="0.4 0 0.6 1;0.4 0 0.6 1" />
        <circle cx="50" cy="48" r="11" fill="var(--st-ui-empty-icon-bg)" stroke="var(--st-ui-empty-icon-color)"
          stroke-width="2.4" />
        <circle cx="50" cy="48" r="8" fill="var(--st-greyscale-grey-1)" />
        <line x1="44" y1="48" x2="56" y2="48" stroke="var(--st-white)" stroke-width="3" stroke-linecap="round" />
      </g>
      }
      }
    </svg>
  </div>
  <p id="st-empty-state-title" class="empty-state-title fs-18 fw-bold mb-1">
    {{ title() || (titleKey() | translate) }}
  </p>
  <p id="st-empty-state-description" class="empty-state-description fs-13 fw-normal mb-0">
    {{ description() || (descriptionKey() | translate) }}
  </p>
</div>